// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gF-z","hovered":"hF-z","hoverImage":"iF-z","mainImage":"jF-z","imageNoBackground":"kF-z","fullSizeImage":"lF-z"};